import React from "react";
import Icon from "./Icon";
export default function Rotate(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M21.0833 3.66667V9.16667H15.5833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7825 13.75C18.1866 15.4366 17.0587 16.8838 15.5688 17.8736C14.0788 18.8634 12.3076 19.3422 10.5219 19.2377C8.73615 19.1332 7.03278 18.4512 5.66841 17.2944C4.30405 16.1377 3.35261 14.5688 2.95747 12.8242C2.56234 11.0797 2.74491 9.25392 3.47768 7.62214C4.21045 5.99037 5.45371 4.64096 7.02013 3.77725C8.58654 2.91354 10.3912 2.58234 12.1623 2.83355C13.9333 3.08475 15.5747 3.90476 16.8391 5.17L21.0833 9.16667"
  }));
}
Rotate.displayname = "Rotate";
//# sourceMappingURL=Rotate.js.map